import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "maximized", "headerProps", "toggleButtonProps", "messagesProps", "suggestionsProps", "promptProps", "headerComponent", "promptComponent", "toggleButtonComponent", "suggestionsComponent", "classNames", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cx } from "../../lib/index.js";
import { createChatHeaderComponent } from "./ChatHeader.js";
import { createChatMessagesComponent } from "./ChatMessages.js";
import { createChatPromptComponent } from "./ChatPrompt.js";
import { createChatPromptSuggestionsComponent } from "./ChatPromptSuggestions.js";
import { createChatToggleButtonComponent } from "./ChatToggleButton.js";
export function createChatComponent(_ref) {
  var createElement = _ref.createElement,
    Fragment = _ref.Fragment;
  var ChatToggleButton = createChatToggleButtonComponent({
    createElement: createElement,
    Fragment: Fragment
  });
  var ChatHeader = createChatHeaderComponent({
    createElement: createElement,
    Fragment: Fragment
  });
  var ChatMessages = createChatMessagesComponent({
    createElement: createElement,
    Fragment: Fragment
  });
  var ChatPrompt = createChatPromptComponent({
    createElement: createElement,
    Fragment: Fragment
  });
  var ChatPromptSuggestions = createChatPromptSuggestionsComponent({
    createElement: createElement,
    Fragment: Fragment
  });
  return function Chat(userProps) {
    var open = userProps.open,
      _userProps$maximized = userProps.maximized,
      maximized = _userProps$maximized === void 0 ? false : _userProps$maximized,
      headerProps = userProps.headerProps,
      toggleButtonProps = userProps.toggleButtonProps,
      messagesProps = userProps.messagesProps,
      suggestionsProps = userProps.suggestionsProps,
      _userProps$promptProp = userProps.promptProps,
      promptProps = _userProps$promptProp === void 0 ? {} : _userProps$promptProp,
      HeaderComponent = userProps.headerComponent,
      PromptComponent = userProps.promptComponent,
      ToggleButtonComponent = userProps.toggleButtonComponent,
      SuggestionsComponent = userProps.suggestionsComponent,
      _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames,
      className = userProps.className,
      props = _objectWithoutProperties(userProps, _excluded);
    return createElement("div", _extends({}, props, {
      className: cx('ais-Chat', maximized && 'ais-Chat--maximized', classNames.root, className)
    }), createElement("div", {
      className: cx('ais-Chat-container', open && 'ais-Chat-container--open', maximized && 'ais-Chat-container--maximized', classNames.container)
    }, createElement(HeaderComponent || ChatHeader, _objectSpread(_objectSpread({}, headerProps), {}, {
      classNames: classNames.header,
      maximized: maximized
    })), createElement(ChatMessages, _extends({}, messagesProps, {
      classNames: classNames.messages,
      messageClassNames: classNames.message,
      suggestionsElement: createElement(SuggestionsComponent || ChatPromptSuggestions, _objectSpread(_objectSpread({}, suggestionsProps), {}, {
        classNames: classNames.suggestions
      }))
    })), createElement(PromptComponent || ChatPrompt, _objectSpread(_objectSpread({}, promptProps), {}, {
      classNames: classNames.prompt
    }))), createElement("div", {
      className: "ais-Chat-toggleButtonWrapper"
    }, createElement(ToggleButtonComponent || ChatToggleButton, _objectSpread(_objectSpread({}, toggleButtonProps), {}, {
      classNames: classNames.toggleButton,
      onClick: function onClick() {
        var _toggleButtonProps$on;
        (_toggleButtonProps$on = toggleButtonProps.onClick) === null || _toggleButtonProps$on === void 0 ? void 0 : _toggleButtonProps$on.call(toggleButtonProps);
        if (!open) {
          var _promptProps$promptRe, _promptProps$promptRe2;
          (_promptProps$promptRe = promptProps.promptRef) === null || _promptProps$promptRe === void 0 ? void 0 : (_promptProps$promptRe2 = _promptProps$promptRe.current) === null || _promptProps$promptRe2 === void 0 ? void 0 : _promptProps$promptRe2.focus();
        }
      }
    }))));
  };
}